import { SiteFooter } from '@/components/site-footer/site-footer';
import { SiteHeader } from '@/components/site-header';
import React from 'react';

type MainLayoutProps = {
  children: React.ReactNode;
};

export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <div data-wrapper="">
      <div className="mx-auto w-full min-[1800px]:max-w-screen-2xl min-[1800px]:border-x">
        <SiteHeader />
        <main className="flex-1">{children}</main>
        <SiteFooter />
      </div>
    </div>
  );
};
